import { LiveDraft } from '@utils/editors/live-transcript-state.ts';

type SectionRange = {
  completed: boolean;
  start_sequence: number;
  end_sequence: number;
};

export const liveSectionHidesDirtyRows = (
  section: SectionRange,
  rows: LiveDraft[]
) => {
  const dirty = rows.filter(row => row.dirty);
  if (!dirty.length) return false;
  if (section.completed) return true;
  return dirty.some(
    row =>
      row.segment.sequence < section.start_sequence ||
      row.segment.sequence > section.end_sequence
  );
};
